import React from "react";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: "primary" | "secondary" | "ghost" | "danger";
    fullWidth?: boolean;
}

const Button: React.FC<ButtonProps> = ({
                                           children,
                                           variant = "primary",
                                           fullWidth = false,
                                           className = "",
                                           ...props
                                       }) => {
    return (
        <button
            className={`ui-button ui-button-${variant} ${fullWidth ? "ui-button-full" : ""} ${className}`.trim()}
            {...props}
        >
            {children}
        </button>
    );
};

export default Button;
